import { render, staticRenderFns } from "./papergrad.vue?vue&type=template&id=e49043b8&scoped=true"
import script from "./papergrad.vue?vue&type=script&lang=js"
export * from "./papergrad.vue?vue&type=script&lang=js"
import style0 from "./papergrad.vue?vue&type=style&index=0&id=e49043b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49043b8",
  null
  
)

export default component.exports